import React, { useState } from "react";
import SchedularStep1 from "../../components/subComponents/SchedularStep1";
import SchedularStep2 from "../../components/subComponents/SchedularStep2";
import SchedularStep3 from "../../components/subComponents/SchedularStep3";

const Schedular: React.FC = () => {
  const [selectedPlaylists, setSelectedPlaylists] = useState<string[]>([]);
  const [selectedScreens, setSelectedScreens] = useState<string[]>([]);
  const [step, setStep] = useState(1);

  return (
    // Step 1 is pinned to the viewport so only its grid scrolls. Steps 2 and 3
    // have no scroll container of their own, so they keep growing the page.
    <div
      className={`m-4 p-2 ${
        step === 1
          ? "flex h-[calc(100%-2rem)] flex-col overflow-hidden"
          : "flex-1"
      }`}
    >
      <h1 className="text-2xl font-bold text-gray-800 mb-4 shrink-0">
        Scheduler
      </h1>

      <div className={step === 1 ? "flex-1 min-h-0" : "flex-1"}>
        {step === 1 && (
          <SchedularStep1
            selected={selectedPlaylists}
            setSelected={setSelectedPlaylists}
          />
        )}
        {step === 2 && (
          <SchedularStep2
            selected={selectedScreens}
            setSelected={setSelectedScreens}
          />
        )}
        {step === 3 && (
          <SchedularStep3
            screenIds={selectedScreens}
            playlistIds={selectedPlaylists}
          />
        )}
      </div>

      {step != 3 && (
        <div className="flex justify-between shrink-0 pt-2">
          {/* Hide Previous on Step 1 */}
          {step > 1 && (
            <button
              className="py-2 px-4 rounded font-medium text-white bg-primary-default hover:bg-primary-light"
              onClick={() => setStep((s) => Math.max(s - 1, 1))}
            >
              Previous
            </button>
          )}
          <div className="flex-1"></div> {/* Spacer */}
          <button
            className={`py-2 px-4 rounded font-medium text-white ${
              (step === 1 && selectedPlaylists.length === 0) ||
              (step === 2 && selectedScreens.length === 0)
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-primary-default hover:bg-primary-light"
            }`}
            disabled={
              (step === 1 && selectedPlaylists.length === 0) ||
              (step === 2 && selectedScreens.length === 0)
            }
            onClick={() => setStep((s) => s + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Schedular;
